import { compose } from 'recompose';
import withPhones from './withPhones';
import withRoles from './withRoles';
import withWorkstationPhoneId from './withWorkstationPhoneId';

export default Component => compose(withRoles, withWorkstationPhoneId, withPhones)(Component);
